import { Employee } from "./employee.type";

export enum ReservationStatus {
  Draft = "draft",
  Created = "created",
  Confirmed = "confirmed",
  Rejected = "rejected",
  Canceled = "canceled",
  Completed = "completed",
  Archived = "archived",
  Missed = "missed",
}

export type Reservation = {
  id: number;
  start_date: string;
  end_date: string;
  status: ReservationStatus;
  comment: string;
  services_sum?: number;
  services: {
    id: number;
    name: string;
  }[];
  customers: {
    id: number;
    name: string;
    phone_number: string;
    email: string;
  }[];
  employees: Employee[];
  url: string;
};

export type ReservationCustomerInput = {
  customer_id?: number;
  name?: string;
  phone_number?: string;
  email?: string;
};

export type ReservationCustomerSearchResult = {
  id: number;
  type: "user" | "customer";
  name: string;
  phone_number: string;
  email: string;
};

export interface UpdateReservationDTO {
  id: number;
  employee_ids?: number[];
  service_ids?: number[];
  start_date?: string;
  end_date?: string;
  status?: ReservationStatus;
  customer?: ReservationCustomerInput;
}

export interface CreateReservationDTO {
  employee_ids?: number[];
  service_ids?: number[];
  start_date?: string;
  end_date?: string;
  status?: ReservationStatus;
  customer?: ReservationCustomerInput;
}
